// src/services/auth.js
import axios from 'axios';
import { BACKENDURL } from '../components/constants';

const AuthService = {
  login: async (email, password) => {
    const response = await axios.post(`${BACKENDURL}/admin/login`, {
      email,
      password
    });
    
    if (response.data.token) {
      localStorage.setItem('admin', JSON.stringify(response.data));
    }
    
    return response.data;
  },

  logout: async () => {
    const admin = JSON.parse(localStorage.getItem('admin'));
    if (admin?.token) {
      try {
        await axios.post(`${BACKENDURL}/admin/logout`, {}, {
          headers: {
            'Authorization': `Bearer ${admin.token}`
          }
        });
      } catch (error) {
        console.error('Logout error:', error);
      }
    }
    localStorage.removeItem('admin');
  },

  getCurrentAdmin: async () => {
    const admin = JSON.parse(localStorage.getItem('admin'));
    if (admin?.token) {
      try {
        const response = await axios.get(`${BACKENDURL}/admin/me`, {
          headers: {
            'Authorization': `Bearer ${admin.token}`
          }
        });
        return response.data;
      } catch (error) {
        console.error('Get current admin error:', error);
        // Fixed: Use AuthService directly instead of 'this'
        await AuthService.logout();
      }
    }
    return null;
  },
  
  // Helper method to check if admin is authenticated
  isAuthenticated: () => {
    const admin = JSON.parse(localStorage.getItem('admin'));
    return !!(admin && admin.token);
  }
};

export default AuthService;